import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import { Dialog } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
// <Modal
//   title="Are you sure this info is correct?"
//   message="Lorem ipsum dolor sit amet, tation scriptorem consequuntur mel ex, pri ex movet commune. Ius at explicari euripidis appellantur, ex vidisse voluptatibus eam, vix eu consul timeam aperiam."
//   submitLabel="Confirm"
//   open={modal1}
//   onClose={() => updateFirstModal(false)}
//   handleSubmit={handleSecondModal}
// >

const useStyles = makeStyles((theme) => ({
  paper: {
    // background: 'none',
    boxShadow: "none",
    display: "block",
    padding: "24px",
    margin: "16px",
    width: "90%",
    maxWidth: "1200px",
    height: "90%",
    maxHeight: "1000px",
    overflow: "hidden",
  },
}));

const Content = styled.div`
  height: 100%;
  max-height: 900px;
  position: relative;
`;

const Header = styled.div`
  background: #fff;
  display: flex;
  justify-content: space-between;
  margin: 0;
  svg {
    fill: #555;
    height: 32px;
    width: 32px;
  }
`;

const Title = styled.label`
  color: #555;
  display: flex;
  align-items: center;
  font-family: ${(props) => props.theme.font.primary};
  font-size: 1.25rem;
  font-weight: 500;
  width: 500px;
  @media (max-width: 900px) {
    width: auto;
  }
  svg {
    fill: ${(props) => props.theme.color.primary};
    height: auto;
    width: 36px;
    margin-right: 16px;
  }
`;

const ModalComponent = (props) => {
  const classes = useStyles();

  return (
    <Dialog
      classes={{ paper: classes.paper }}
      fullScreen
      open={props.open}
      onClose={props.onClose}
    >
      <Header>
        <Title>{props.title}</Title>
        <IconButton
          key="close"
          aria-label="close"
          color="inherit"
          onClick={props.onClose}
        >
          <CloseIcon />
        </IconButton>
      </Header>
      <Content>{props.children}</Content>
    </Dialog>
  );
};

ModalComponent.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string,
  message: PropTypes.string,
  submitLabel: PropTypes.string,
  handleSubmit: PropTypes.func,
};

export default ModalComponent;
